export const testimonials = [
  {
    name: 'Dr. Michael Chen',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ec3a18f1-bd6c-4eb1-9a87-73e2753a4003.jpg',
    quote: 'The movement-risk matrices make it easier to organize the clinical factors I want to evaluate before approving a setup. I especially appreciate the visual structure.',
  },
  {
    name: 'Dr. Emily Hartman',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4317500b-5475-4f6b-9a1d-3659e2b260d5.jpg',
    quote: 'The planning blueprint provides a useful framework for thinking through movement sequencing and treatment objectives instead of focusing only on the final simulation.',
  },
  {
    name: 'Dr. Marcus Bennett',
    role: 'Orthodontist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c5601742-67ec-436c-8126-d9a93e4fd412.jpg',
    quote: 'The movement atlas is particularly helpful because it brings several biomechanical concepts together in one visual reference.',
  },
  {
    name: 'Dr. Grace Liu',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d45d3fae-74d7-40e8-8bf5-908ea44f0f1b.jpg',
    quote: 'I like having a structured checklist for reviewing digital setups. It’s a practical way to organize important clinical questions.',
  },
  {
    name: 'Dr. Daniel Ortega',
    role: 'Clear Aligner Provider',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/0ed16310-41f3-4127-a1dd-0645d92dd0de.jpg',
    quote: 'The tracking assessment pathways help organize the questions that need to be considered when treatment progress differs from the original plan.',
  },
  {
    name: 'Dr. Karen Whitfield',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8509a30d-a0bd-4acb-88e6-224fb98276cc.jpg',
    quote: 'The case planning workbook keeps my movement assessments, setup reviews, and follow-up notes in one place. It has made my case reviews far more organized.',
  },
];
